var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavouriteSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6311 7.44644L13.7491 7.72329L14.049 7.74858L20.7715 8.31559L15.6677 12.7111L15.438 12.909L15.5072 13.2042L17.041 19.7405L11.2573 16.27L11 16.1157L10.7427 16.27L4.95708 19.7416L6.48193 13.2036L6.55063 12.909L6.32163 12.7114L1.227 8.31571L7.95102 7.74858L8.25092 7.72329L8.36895 7.44644L11 1.27495L13.6311 7.44644Z",
    fill: "#E522BC",
    fillOpacity: 0.5,
    stroke: "#17ECB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteSelected);
export default __webpack_public_path__ + "static/media/favourite-selected.17b46432e6b36ad234bc12b76460b53f.svg";
export { ForwardRef as ReactComponent };